/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base box-shadow styles for the Material Dashboard 2 React.
 * You can add new box-shadow using this file.
 * You can customized the box-shadow for the entire Material Dashboard 2 React using thie file.
 */

// Material Dashboard 2 React Base Styles
import colors from "app/theme/base/colors";

// Material Dashboard 2 React Helper Functions
import boxShadow from "app/theme/functions/boxShadow";

const { black, white, tabs, coloredShadows } = colors;

const boxShadows = {
  xs: boxShadow([0, 1], [2, 0], black.main, 0.04),
  sm: boxShadow([0, 1], [3, 0], black.main, 0.06),
  md: boxShadow([0, 1], [3, 0], black.main, 0.08),
  lg: `${boxShadow([0, 8], [18, -6], black.main, 0.14)}, ${boxShadow(
    [0, 2],
    [6, -2],
    black.main,
    0.06
  )}`,
  xl: `${boxShadow([0, 16], [24, -8], black.main, 0.16)}, ${boxShadow(
    [0, 10],
    [10, -8],
    black.main,
    0.08
  )}`,
  xxl: boxShadow([0, 18], [36, -12], black.main, 0.22),
  inset: boxShadow([0, 1], [2, 0], black.main, 0.06, "inset"),
  colored: {
    primary: `${boxShadow([0, 2], [8, -4], black.main, 0.1)}, ${boxShadow(
      [0, 7],
      [10, -8],
      coloredShadows.primary,
      0.12
    )}`,
    secondary: `${boxShadow([0, 2], [8, -4], black.main, 0.1)}, ${boxShadow(
      [0, 7],
      [10, -8],
      coloredShadows.secondary,
      0.1
    )}`,
    info: `${boxShadow([0, 2], [8, -4], black.main, 0.1)}, ${boxShadow(
      [0, 7],
      [10, -8],
      coloredShadows.info,
      0.12
    )}`,
    success: `${boxShadow([0, 2], [8, -4], black.main, 0.1)}, ${boxShadow(
      [0, 7],
      [10, -8],
      coloredShadows.success,
      0.12
    )}`,
    warning: `${boxShadow([0, 2], [8, -4], black.main, 0.1)}, ${boxShadow(
      [0, 7],
      [10, -8],
      coloredShadows.warning,
      0.12
    )}`,
    error: `${boxShadow([0, 2], [8, -4], black.main, 0.1)}, ${boxShadow(
      [0, 7],
      [10, -8],
      coloredShadows.error,
      0.12
    )}`,
    light: `${boxShadow([0, 2], [8, -4], black.main, 0.08)}, ${boxShadow(
      [0, 7],
      [10, -8],
      coloredShadows.light,
      0.08
    )}`,
    dark: `${boxShadow([0, 2], [8, -4], black.main, 0.1)}, ${boxShadow(
      [0, 7],
      [10, -8],
      coloredShadows.dark,
      0.12
    )}`,
  },

  navbarBoxShadow: `${boxShadow([0, 0], [1, 1], white.main, 0.9, "inset")}, ${boxShadow(
    [0, 20],
    [27, 0],
    black.main,
    0.05
  )}`,
  sliderBoxShadow: {
    thumb: boxShadow([0, 1], [13, 0], black.main, 0.2),
  },
  tabsBoxShadow: {
    indicator: boxShadow([0, 1], [5, 1], tabs.indicator.boxShadow, 1),
  },
};

export default boxShadows;
